export const OPEN_ITEM_ID = '80000000-0000-0000-0000-000000000001'

export const isOpenItemId = (itemId: string | undefined) =>
    itemId === OPEN_ITEM_ID
